import requestProvider from "./axiosHandler";

const getAllOffer = () => {

    return requestProvider
        .get('/bid/get-all')
};

const getAllOfferAsSelect = () => {
    return requestProvider
        .get('/bid/select')
};

const createOffer = (list) => {

    return requestProvider
        .post('/bid', {
            dateOfBid: list.dateOfBid,
            delivery: list.delivery,
            exchangeRate: list.exchangeRate,
            note: list.note,
            payment: list.payment,
            representative: list.representative,
            contentOfBidList: list.contentOfBidList,
            customer: list.customer
        })
};

const updateOffer = (list) => {

    return requestProvider
        .put('/bid', {
            id: list.id,
            bidStatus: list.bidStatus,
            dateOfBid: list.dateOfBid,
            delivery: list.delivery,
            exchangeRate: list.exchangeRate,
            note: list.note,
            payment: list.payment,
            representative: list.representative,
            contentOfBidList: list.contentOfBidList,
            customer: list.customer
        })
};

const deleteOffer = (id) => {

    return requestProvider
        .delete(`/bid/${id}`)
};

const getOfferById = (id) => {
    return requestProvider
        .get(`/bid/${id}`)
};

const getDetailById = (id) => {
    return requestProvider
        .get(`/bid/detail/${id}`)
};

const getStockDetails = (id) => {
    return requestProvider
        .get(`/bid/get-by-stock/${id}`)
};

const setOfferRejection = (list) => {
    return requestProvider
        .post('/bid/set-rejection-reason', list)
};

const getWithSubTotals = () => {
    return requestProvider
        .get('/bid/getall-with-subtotal')
};

const offerFilter = (list) => {
    return requestProvider
        .post('bid/sub-filter',list)
};

/*
* @param bidStatus
* @type String
* @values (NEGATIVE, POSITIVE)
*
* @param id (int)
* @type Number
* */
const toggleBidContentStatus = (list) => {
    return requestProvider
        .post('content-of-bid/change-status', list)
};

/*
* @param Object
* @structure {id: @type Number}
* */
const cloneBid = (list) => {
    return requestProvider
        .post('bid/clone', list)
};


const getOffersWithPage = (list) => {
    return requestProvider
        .post('bid/page-filter', list);
}

export {
    offerFilter, 
    setOfferRejection, 
    cloneBid,
    getAllOffer, 
    toggleBidContentStatus, 
    createOffer, 
    updateOffer, 
    deleteOffer, 
    getOfferById, 
    getDetailById, 
    getStockDetails,
    getWithSubTotals, 
    getAllOfferAsSelect,
    getOffersWithPage 
}